import React from 'react'
import { useCalculateTypography } from 'src/editor/shared/hooks/use-calculate-typography'
import {
  FontSelectorControl,
  FontSelectorControlProps,
} from '../../controls/font-selector-control'
import {
  UseFontSelectorProps,
  useFontSelector,
} from '../../hooks/use-font-selector'

export interface EntityFontSelectorControlProps<
  Entity extends Record<string, any>,
  FontFamilyKey extends keyof Entity,
  FontWeightKey extends keyof Entity,
  FontStyleKey extends keyof Entity,
  FontFileIdKey extends keyof Entity,
  MobileFontFamilyKey extends keyof Entity,
  MobileFontWeightKey extends keyof Entity,
  MobileFontStyleKey extends keyof Entity,
  MobileFontFileIdKey extends keyof Entity,
> extends UseFontSelectorProps<
      Entity,
      FontFamilyKey,
      FontWeightKey,
      FontStyleKey,
      FontFileIdKey,
      MobileFontFamilyKey,
      MobileFontWeightKey,
      MobileFontStyleKey,
      MobileFontFileIdKey
    >,
    Omit<FontSelectorControlProps, 'inheritedFontTypeLabel' | 'update'> {}

export const EntityFontSelectorControl = <
  Entity extends Record<string, any>,
  FontFamilyKey extends keyof Entity,
  FontWeightKey extends keyof Entity,
  FontStyleKey extends keyof Entity,
  FontFileIdKey extends keyof Entity,
  MobileFontFamilyKey extends keyof Entity,
  MobileFontWeightKey extends keyof Entity,
  MobileFontStyleKey extends keyof Entity,
  MobileFontFileIdKey extends keyof Entity,
>({
  object,
  fontFamilyKey,
  fontWeightKey,
  fontStyleKey,
  fontFileIdKey,
  mobileFontFamilyKey,
  mobileFontWeightKey,
  mobileFontStyleKey,
  mobileFontFileIdKey,
  updateObject,

  labelText,
  hideLabel,
  isRootSetting,

  fontFamily,
  mobileFontFamily,
  fontWeight,
  mobileFontWeight,
  fontStyle,
  mobileFontStyle,
  globalFontFamily,
  mobileGlobalFontFamily,
}: EntityFontSelectorControlProps<
  Entity,
  FontFamilyKey,
  FontWeightKey,
  FontStyleKey,
  FontFileIdKey,
  MobileFontFamilyKey,
  MobileFontWeightKey,
  MobileFontStyleKey,
  MobileFontFileIdKey
>) => {
  const { inheritedFontTypeLabel, updateObjectFont } = useFontSelector({
    object,
    fontFamilyKey,
    fontWeightKey,
    fontStyleKey,
    fontFileIdKey,
    mobileFontFamilyKey,
    mobileFontWeightKey,
    mobileFontStyleKey,
    mobileFontFileIdKey,
    updateObject,
  })

  return (
    <FontSelectorControl
      update={updateObjectFont}
      labelText={labelText}
      hideLabel={hideLabel}
      globalFontFamily={globalFontFamily}
      mobileGlobalFontFamily={mobileGlobalFontFamily}
      inheritedFontTypeLabel={inheritedFontTypeLabel}
      isRootSetting={isRootSetting}
      fontFamily={fontFamily}
      mobileFontFamily={mobileFontFamily}
      fontWeight={fontWeight}
      mobileFontWeight={mobileFontWeight}
      fontStyle={fontStyle}
      mobileFontStyle={mobileFontStyle}
    />
  )
}
